










import { Component, Prop, Vue , Watch } from "vue-property-decorator";
import CommonLayerDrawer from '@/views/designEditor/canvasWindow/layerDrawer/commonLayerDrawer/commonLayerDrawer.vue';

import * as def from '@/definitions'
// TODO document2
import { Design } from '@/model/document2/page/surface/design/design'

import { UnitHelper } from '@/helper/unitHelper';
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
      CommonLayerDrawer
  },
})
export default class DesignView extends Vue {
    @Prop() private design! : Design;
    @Prop() private index! : number;

    private isDragging = false;

    // viewBox幅
    private get viewWidth() : number
    {
        return UnitHelper.convert(this.design.width, "mm", "px");
    }

    // viewBox高さ
    private get viewHeight() : number
    {
        return UnitHelper.convert(this.design.height, "mm", "px");
    }

    // viewBox
    private get viewBox() : string
    {
        return "0 0 " + this.viewWidth + " " + this.viewHeight;
    }

    private get allLayers()
    {
        return this.design.getAllLayers(false);
    }

    private get scale()
    {
        return UnitHelper.convert(1, "mm", "px");
    }

    private get svgStyle()
    {
        var w = 100;
        var h = 100;
        if(this.design.height > this.design.width)
        {
            w = h * this.design.width / this.design.height;
        }
        else
        {
            h = w * this.design.height / this.design.width;
        }
        var x = (100 - w) / 2;
        var y = (100 - h) / 2;

        return {
            position: "absolute",
            top: y + "%",
            left: x + "%",
            width: w + "%",
            height: h + "%"
        };
    }

    private get transform()
    {
        var transform = "";
        return transform;
    }

    private onDragStart(e)
    {
        // ドラッグフラグON : styleを変更する
        this.isDragging = true;

        // FireFoxではsetDataしないとdragendが呼ばれない
        // IEだと例外になるのでtry-catch
        try
        {
            e.dataTransfer.setData('text/plain', 'dummy');
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
        // マウスポインタを移動モードに変更
        e.dataTransfer.effectAllowed = "move";
        // ドラッグ開始イベント
        this.$emit("dragDesignStart", this.index);
    }

    private onDragEnd(e)
    {
        // ドラッグフラグOFF : styleを変更する
        this.isDragging = false;

        // ドラッグ終了イベント
        this.$emit("dragDesignEnd");
    }

}
